module.exports = __webpack_public_path__ + "UX19.png?9a7b35b016d1b784c40b811039921765";


//////////////////
// WEBPACK FOOTER
// ./src/assets/UX19.png
// module id = 68
// module chunks = 0